var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "16px",
    viewBox: "0 0 21 16",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.7957 3.23923C19.7957 3.23923 19.5888 1.77303 19.0025 1.1252C18.2438 0.272774 17.3816 0.272774 17.0023 0.238668C14.2088 0.0341065 10.0013 0 10.0013 0L10.0013 0C10.0013 0 5.79386 0.0341065 3.0004 0.238668C2.62105 0.272774 1.75887 0.306881 1.00013 1.1252C0.379348 1.77307 0.206942 3.23923 0.206942 3.23923C0.206942 3.23923 0 4.97819 0 6.71716L0 8.31974C0 10.0587 0.206942 11.7636 0.206942 11.7636C0.206942 11.7636 0.413883 13.2298 1.00013 13.8776C1.75887 14.73 2.759 14.6959 3.20734 14.7982C4.79373 14.9686 10.0013 15.0028 10.0013 15.0028C10.0013 15.0028 14.2088 15.0028 17.0023 14.7641C17.3816 14.73 18.2438 14.6959 19.0025 13.8775C19.5888 13.2297 19.7957 11.7635 19.7957 11.7635C19.7957 11.7635 20.0027 10.0246 20.0027 8.3197L20.0027 6.71712C20.0027 4.97819 19.7957 3.23923 19.7957 3.23923",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask-group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7957 3.23923C19.7957 3.23923 19.5888 1.77303 19.0025 1.1252C18.2438 0.272774 17.3816 0.272774 17.0023 0.238668C14.2088 0.0341065 10.0013 0 10.0013 0L10.0013 0C10.0013 0 5.79386 0.0341065 3.0004 0.238668C2.62105 0.272774 1.75887 0.306881 1.00013 1.1252C0.379348 1.77307 0.206942 3.23923 0.206942 3.23923C0.206942 3.23923 0 4.97819 0 6.71716L0 8.31974C0 10.0587 0.206942 11.7636 0.206942 11.7636C0.206942 11.7636 0.413883 13.2298 1.00013 13.8776C1.75887 14.73 2.759 14.6959 3.20734 14.7982C4.79373 14.9686 10.0013 15.0028 10.0013 15.0028C10.0013 15.0028 14.2088 15.0028 17.0023 14.7641C17.3816 14.73 18.2438 14.6959 19.0025 13.8775C19.5888 13.2297 19.7957 11.7635 19.7957 11.7635C19.7957 11.7635 20.0027 10.0246 20.0027 8.3197L20.0027 6.71712C20.0027 4.97819 19.7957 3.23923 19.7957 3.23923",
    id: "Shape",
    fill: "#333238",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 3.67877L0 6.0011C0 6.0011 0.214368 5.89638 1.71457 5.16353C3.21476 4.43068 6.00079 3.06971 6.00079 3.06971L3.90622 1.99823L0 0Z",
    transform: "translate(8.001221 4.000732)",
    id: "Shape",
    fill: "#FFFFFF",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.d61fdeb2194e2910cf25cfcafd589794.svg";
export { ForwardRef as ReactComponent };